import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import websitelogo from '../../../../assets/logos/websitelogo.svg';
import './ForgotPassword.css';
import {
	Box,
	CssBaseline,
	Grid,
	InputAdornment,
	OutlinedInput,
	Snackbar,
	Typography,
} from '@mui/material';

import Paper from '@mui/material/Paper';
import { forgotPassword } from '../../../services/api/apiManager';
import Button from '@mui/material/Button';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import { LockResetRounded, LoginRounded } from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';

function ForgotPassword() {
	const defaultTheme = createTheme();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [error, setError] = useState(null);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarOpenError, setSnackbarOpenError] = useState(false);
	const [snackbarOpenSuccess, setSnackbarOpenSuccess] = useState(false);

	const handleSendPasscodeClick = async () => {
		try {
			if (!email.trim()) {
				// If email is empty or contains only whitespace
				setSnackbarOpen(true);
				return;
			}
			debugger;

			const formData = new FormData();
			formData.append('email', email);
			const data = { email: email };
			// Call the forgotPassword function with the formData
			const res = await forgotPassword(data);
			if (res && res?.status === 200) {
				setSnackbarOpenSuccess(true);

				setTimeout(() => {
					navigate('/');
				}, 1500);
			} else {
				setSnackbarOpenError(true);
			}
			// Handle the success response
		} catch (error) {
			// Handle errors from the API call
			setError('Error occurred while resetting password. Please try again.');
		}
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				className="forgot-page"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/Authentication-bg.webp')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '28px 36px',
					'@media (max-width: 600px)': {
						padding: '14px',
					},
				}}
			>
				<CssBaseline />
				<Grid
					container
					item
					justifyContent="center"
					className="forgot-shell"
					sx={{
						maxWidth: '1080px',
						borderRadius: '24px',
						overflow: 'hidden',
						boxShadow: '0 28px 70px rgba(74, 95, 132, 0.22)',
						backgroundColor: 'rgba(255,255,255,0.68)',
						border: '1px solid rgba(255,255,255,0.72)',
						backdropFilter: 'blur(8px)',
					}}
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={5.5}
						xl={5.5}
						className="forgot-brand-panel"
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							minHeight: '490px',
							display: { sm: 'none', xs: 'none', md: 'flex' },
						}}
					>
						<Box className="forgot-brand-logo">
						</Box>
						<Box className="forgot-brand-copy">
							<Typography
								variant="h3"
								className="forgot-brand-title"
							>
								Reset your password
							</Typography>
							<Box className="forgot-brand-accent" />
							<Typography
								variant="h6"
								className="forgot-brand-subtitle"
							>
								Enter your email address and we&apos;ll help you get back into
								your account quickly.
							</Typography>
						</Box>
						<Box className="forgot-brand-footer">
							<Box className="forgot-feature-card">
								<Box className="forgot-feature-icon">
									<LockResetRounded />
								</Box>
								<Box>
								<Typography className="forgot-feature-title">
									Secure recovery
								</Typography>
								<Typography className="forgot-feature-text">
									We only send reset access to the registered email address.
								</Typography>
								</Box>
							</Box>
							<Box className="forgot-feature-divider" />
							<Box className="forgot-feature-card">
								<Box className="forgot-feature-icon">
									<LoginRounded />
								</Box>
								<Box>
								<Typography className="forgot-feature-title">
									Quick redirect
								</Typography>
								<Typography className="forgot-feature-text">
									Once sent, you can head back and continue the sign-in flow.
								</Typography>
								</Box>
							</Box>
						</Box>
						<Box className="forgot-links-row">
							<Box className="forgot-link-item">
								<ContactSupportIcon className="forgot-link-icon" />
								<Link to={'/aboutUs'} className="forgot-side-link">
									<Typography>About Us</Typography>
								</Link>
							</Box>
							<Box className="forgot-link-item">
								<CallIcon className="forgot-link-icon" />
								<Link to={'/contactUs'} className="forgot-side-link">
									<Typography>Contact Us</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
					<Grid
						component={Paper}
						elevation={6}
						square
						item
						xs={12}
						sm={12}
						md={6}
						lg={6.5}
						xl={6.5}
						className="forgot-form-panel"
						sx={{
							background: 'rgba(255,255,255,0.96)',
							padding: { xs: '18px 14px', sm: '20px 18px', md: '20px 24px' },
							'@media (max-width: 600px)': {
								minHeight: 'auto',
							},
						}}
					>
						<Box className="forgot-form-wrap">
							<Box className="forgot-form-logo">
								<img
									src={websitelogo}
									alt="MaxCharts"
									style={{
										width: '190px',
										height: 'auto',
										objectFit: 'contain',
									}}
								/>
							</Box>
							<Typography
								component="h1"
								variant="h4"
								className="forgot-form-title"
							>
								Forgot Password
							</Typography>
							<Typography className="forgot-form-subtitle">
								Enter your email and we&apos;ll send you a new password.
							</Typography>
							<Box noValidate className="forgot-form">
								<Typography
									variant="body2"
									className="forgot-field-label"
								>
									Email Address
								</Typography>

								<OutlinedInput
									className="forgot-input"
									fullWidth
									type="email"
									name="email"
									autoComplete="email"
									size="small"
									required
									id="email"
									placeholder="Enter your email address"
									onChange={(e) => setEmail(e.target.value)}
									startAdornment={
										<InputAdornment position="start">
											<MailOutlineOutlinedIcon className="forgot-input-icon" />
										</InputAdornment>
									}
								/>

								<Button
									variant="contained"
									fullWidth
									className="forgot-submit"
									sx={{
										background: '#e87511',
										color: 'white',
										borderRadius: '10px',
										height: '44px',
										width: '100%',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '600',
										marginTop: '8px',
										marginBottom: '14px',
										'&:hover': {
											background: '#e87511',
										},
									}}
									onClick={handleSendPasscodeClick}
								>
									Send Passcode
								</Button>
								<Box className="forgot-divider-row">
									<Box className="forgot-divider-line" />
									<Box className="forgot-divider-badge">or</Box>
									<Box className="forgot-divider-line" />
								</Box>
								<Box className="forgot-login-row">
									<Typography className="forgot-login-text">
										Remembered your password?
									</Typography>
									<Link to={'/'} className="forgot-login-link">
										<Typography>Login</Typography>
									</Link>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpen}
					autoHideDuration={2000}
					onClose={() => setSnackbarOpen(false)}
					message="Please enter your email."
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpen(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: 'red',
							color: 'white',
							fontFamily: 'Poppins',
						},
					}}
				/>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpenError}
					autoHideDuration={2000}
					onClose={() => setSnackbarOpenError(false)}
					message="Email not Registered. Please enter valid Email "
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpen(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: 'red',
							color: 'white',
							fontFamily: 'Poppins',
						},
					}}
				/>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbarOpenSuccess}
					autoHideDuration={1500}
					onClose={() => setSnackbarOpenSuccess(false)}
					message="New Password Sent Check Your email"
					action={
						<React.Fragment>
							<Button
								sx={{ color: 'white' }}
								size="small"
								onClick={() => setSnackbarOpenSuccess(false)}
							>
								CLOSE
							</Button>
						</React.Fragment>
					}
					ContentProps={{
						sx: {
							backgroundColor: '#3EAE4D',
							color: 'white',
							fontFamily: 'Poppins',
							fontWeight: '300',
						},
					}}
				/>
			</Grid>
		</ThemeProvider>
	);
}
export default ForgotPassword;
